// Router.jsx
import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import RecuperarSenhaInstituicao from "./views/RecuperarSenhaInstituicao";
import ResetarSenhaInstituicao from "./views/ResetarSenhaInstituicao";
import Login from "./views/login";
import Home from "./views/home";
import CadastroAluno from "./views/CadastroAluno";
import CadastroObrigado from "./views/CadastroObrigado/CadastroObrigado";
// Dashboards novas (placeholders por enquanto)
const DashboardProfessor = lazy(() =>
  import("./views/DashboardProfessor/DashboardProfessor")
);
const DashboardInstituicao = lazy(() =>
  import("./views/DashboardInstituicao/DashboardInstituicao")
);

const Router = () => (
  <Suspense fallback={<div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#888' }}>Carregando...</div>}>
    <Routes>
      {/* Públicas */}
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/cadastro" element={<CadastroAluno />} />
      <Route path="/cadastro/obrigado" element={<CadastroObrigado />} />
      <Route path="/recuperar-senha" element={<RecuperarSenhaInstituicao />} />
      <Route path="/resetar-senha" element={<ResetarSenhaInstituicao />} />

      {/* Privadas */}
      <Route element={<PrivateRoute />}>
        <Route path="/dashboard/professor" element={<DashboardProfessor />} />
        <Route path="/dashboard/instituicao" element={<DashboardInstituicao />} />

        {/* opcional/conservador: qualquer /dashboard antigo cai na home */}
        <Route path="/dashboard" element={<Navigate to="/" replace />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Suspense>
);

export default Router;
